// These four catalogue images were renamed on Ezzo. Limit compatibility to the
// verified old URLs so an unrelated product can never acquire a substitute photo.
const aliases: Record<string, string> = {
  'https://www.ezzo.sg/images/products/emd-skylight-sunroof-01.jpg': 'https://www.ezzo.sg/images/products/ezzo-skylight-sunroof-01.jpg',
  'https://www.ezzo.sg/images/products/emd-skylight-roof-01.jpg': 'https://www.ezzo.sg/images/products/ezzo-skylight-roof-01.jpg',
  'https://www.ezzo.sg/images/products/emd-skylight-sliding-01.png': 'https://www.ezzo.sg/images/products/ezzo-skylight-sliding-01.png',
  'https://www.ezzo.sg/images/products/emd-skylight-detail-01.jpg': 'https://www.ezzo.sg/images/products/ezzo-skylight-detail-01.jpg',
};
export function normalizeProductMedia<T>(product: T): T {
  if (!product || typeof product !== 'object') return product;
  const copy = { ...product } as T & Record<string, unknown>;
  for (const key of ['image_url', 'image', 'gallery_images', 'images', 'media']) {
    const value = copy[key];
    const normalize = (item: unknown): unknown => typeof item === 'string'
      ? (aliases[item] || item)
      : item && typeof item === 'object' ? Object.fromEntries(Object.entries(item).map(([k, v]) => [k, typeof v === 'string' ? (aliases[v] || v) : v])) : item;
    if (value !== undefined) (copy as Record<string, unknown>)[key] = Array.isArray(value) ? value.map(normalize) : normalize(value);
  }
  return copy;
}
